const roundToNearest = (value: number) => {
  const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
  const lowerBound = Math.floor(value / magnitude) * magnitude;
  const upperBound = Math.ceil(value / magnitude) * magnitude;

  // Check which bound is closer to the original value
  return value - lowerBound < upperBound - value ? lowerBound : upperBound;
};

const isAlreadyRounded = (value: number) => {
  const magnitude = Math.pow(10, Math.floor(Math.log10(value) - 1));
  return value % magnitude === 0;
};

const shouldRound = (value: number, threshold = 0.2) => {
  if (isAlreadyRounded(value)) {
    return false; // Don't round if the number is already rounded
  }

  const nearestValue = roundToNearest(value);
  return Math.abs(nearestValue - value) / value > threshold;
};

export const formatNumber = (num: number) => {
  if (num >= 10000000) {
    return (num / 10000000).toFixed(1) + ' cr';
  } else if (num >= 100000) {
    return (num / 100000).toFixed(1) + ' L';
  } else {
    return num.toLocaleString(); // For smaller numbers, keep it as is
  }
};
export const generateIncomeLabel = (steps: number, maxValue: number) => {
  const stepValue = maxValue / steps; // 2000000 / 4 = 500000
  const labels = Array.from({ length: steps + 1 }, (_, i) => stepValue * i);
  return labels.map(formatNumber);
};
export const getFinalMaxValue = (value: number, threshold = 0.2) => {
  return shouldRound(value, threshold) ? roundToNearest(value) : value;
};

export const previewText =
  'Have you tried the ClearTax income tax calculator yet? It’s accurate and free! Find out your tax payable now.';

export const CALCULATOR_PERMALINK = [
  'taxcalculator',
  'taxcalculator-v1',
  'hracalculator',
  'advancetaxcalculator',
];

export const calculatorContentMap: { [key: string]: string } = {
  taxcalculator: 'Last updated on 1 Feb 2026',
  advancetaxcalculator:
    'Calculate advance tax due for quarter September to December of FY 2025-2026 to be paid on or before 15 December 2025.Enter values as estimated for the year ending on 31 Mar 2026',
};

export const toggleFinancialYear = (year: string): string => {
  return year === '2026' ? '2025' : '2026';
};
